export const onboardingQuestion = `
query Saber {
  onboarding_questions
}
`

export const onboardingQuestionV2 = `
query Saber2 {
  subscriber_onboarding_questions
}
`

export const createOnboardingToteInput = `
mutation CreateOnboardingTote($input: CreateOnboardingToteInput!) {
  CreateOnboardingTote(input: $input) {
    errors
  }
}
`

export const createCustomerAttributes = `
mutation CreateCustomerAttributes($input: CreateCustomerAttributesInput!) {
  CreateCustomerAttributes(input: $input) {
     success errors 
  }
}
`

export const queryCreateCustomerOnboardingAttributes = `
mutation CreateCustomerOnboardingAttributes($input: CreateCustomerOnboardingAttributesInput!) {
  CreateCustomerOnboardingAttributes(input: $input) {
     success
     errors 
  }
}
`
